import React from 'react';

var configPromise = require('../../config').configPromise;

var Version = React.createClass({
  getInitialState: function () {
    return {
      version: ''
    }
  },

  componentWillMount: function () {
    configPromise.then(this._onChange);
  },


  render: function () {
    return (
      <div className="version">
        {`version: ${this.state.version}`}
      </div>
    );
  },

  _onChange: function (config) {
    this.setState({
      version: config.version
    });
  }

});

module.exports = Version;
